// store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const accountTypeSlice = createSlice({
  name: "account",
  initialState: {
    accountTypeId: 1,
    applicantCountry: 1,
    applicationType: localStorage.getItem("applicationType") || 1,
    applicationTypeShareHolder: localStorage.getItem("applicationTypeShareHolder") || 1,
  },
  reducers: {
    setAccountTypeId: (state, action) => {
      state.accountTypeId = action.payload;
    },
    clearAccountTypeId: (state) => {
      state.accountTypeId = 1;
    },
    setApplicantCountry: (state, action) => {
      state.applicantCountry = action.payload;
    },
    clearApplicantCountry: (state) => {
      state.applicantCountry = 1;
    },
    setApplicationType: (state, action) => {
      localStorage.setItem("applicationType", action.payload);
      state.applicationType = action.payload;
    },
    clearApplicationType: (state) => {
      localStorage.removeItem("applicationType");
      state.applicationType = 1;
    },
    setApplicationTypeShareHolder: (state, action) => {
      localStorage.setItem("applicationTypeShareHolder", action.payload);
      state.applicationTypeShareHolder = action.payload;
    },
    clearApplicationTypeShareHolder: (state) => {
      localStorage.removeItem("applicationTypeShareHolder");
      state.applicationTypeShareHolder = 1;
    },
  },
});

export const {
  setAccountTypeId,
  clearAccountTypeId,
  setApplicantCountry,
  clearApplicantCountry,
  setApplicationType,
  clearApplicationType,
  setApplicationTypeShareHolder,
  clearApplicationTypeShareHolder,
} = accountTypeSlice.actions;
export default accountTypeSlice.reducer;
